import sx from 'utils/createSx';

export default sx({
  container: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
  },
  loadingBox: {
    flex: 1,
    minHeight: 200,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
